import React, { Component } from 'react';
import RugAPI from '../../../api/rug'


export default class RugYarns extends Component {

    // this.props.selectedBrands.indexOf(brand.id) !== -1

    constructor(props) {
        super(props)
        this.state = {
            yarns: [],
        }
    }

    loadYarns = () => {
        const api = new RugAPI()
        api.getRugYarns().then(response => {
            if (response.success) {
                this.setState({ yarns: response.data })
            }
        })
    }

    componentDidMount() {
        this.loadYarns()
    }

    render() {
        return (
            <div className={this.props.activeFilters.indexOf("yarns") !== -1 ? "items-body" : "items-body active"}>
                <div className="d-grid">
                    {this.state.yarns.map((yarn, i) =>
                        <label className="filter-effect-input" key={yarn + i}>
                            {yarn.name}
                            <input type="checkbox" checked={this.props.selectedYarns.indexOf(yarn.id) !== -1} onChange={() => this.props.changeHandler("yarns", yarn.id)} />
                            <span className="checkmark"></span>
                        </label>
                    )}
                </div>
            </div>
        )
    }
}